<template>
  <v-app id="inspire" class="fontLao">
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>Stock</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="ຊອກຫາ" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-select
          v-if="displaysl"
          style=" margin-top: 18px; "
          :items="[{val:1,txt:'Import - Export'},{val:2,txt:'Import'},{val:3,txt:' Export'},{val:4,txt:'Products Stock'},{val:5,txt:'3M Products'}]"
          item-text="txt"
          item-value="val"
          v-model="sldisplay"
          @change="checkdisplay"
        ></v-select>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table v-if="sldisplay < 4" :headers="headers" :items="mydata" :search="search" :rows-per-page-items=[100,500,1000] class="elevation-1  fixtable">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.date }}</td>
          <td>{{ props.item.import_export}}</td>
          <td>{{ props.item.categorie }}</td>
          <td>{{ props.item.stockno }}</td>
          <td>{{ props.item.barcode }}</td>
          <td>{{ props.item.unit }}</td>
          <td>{{ props.item.product }}</td>
          <td>{{ props.item.customer_supplier }}</td>
          <!-- <td>{{ props.item.taxid }}</td> -->
          <!-- <td>{{ props.item.vat }}</td> -->
          <td>{{ props.item.discount }}</td>
          <td>{{ props.item.price }}</td>
          <td>{{ props.item.qty }}</td>
          <td>{{ props.item.shipped }}</td>
          <td>
            <span v-if="props.item.back > 0" class="red--text">{{ props.item.back }}</span>
            <span v-if="props.item.back == 0">{{ props.item.back }}</span>
          </td>
          <td>
            {{ _P(props.item.amount) }}
          </td>
          <td>{{ props.item.stock }}</td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">ກົດເລີ່ມໃໝ່</v-btn>
        </template>
      </v-data-table>
      <!--
      barcode stockno product categorie unit price qty shipped back stockin balance saleout date
      -->
      <v-data-table v-if="sldisplay == 4" :headers="headerspro" :items="mydatapro" :search="search" :rows-per-page-items=[10,20,50,100,500] class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.barcode }}</td>
          <td>{{ props.item.stockno}}</td>
          <td>{{ props.item.product }}</td>
          <td>{{ props.item.categorie }}</td>
          <td>{{ props.item.unit }}</td>
          <td>{{ _P(props.item.price) }}</td>
          <td>{{ props.item.qty }}</td>
          <td>{{ props.item.shipped }}</td>
          <td>
            <span v-if="props.item.back > 0" class="red--text">{{ props.item.back }}</span>
            <span v-if="props.item.back == 0">{{ props.item.back }}</span>
          </td>
          <td>{{ props.item.stockin }}</td>
          <td>{{ _P(props.item.stockinamount) }}</td>
          <td>{{ props.item.saleout }}</td>
          <td>{{ _P(props.item.saleoutamount) }}</td>
          <!-- <td>{{ props.item.date }}</td> -->
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initializepro">ກົດເລີ່ມໃໝ່</v-btn>
        </template>
      </v-data-table>
      <v-data-table v-if="sldisplay == 5" :headers="headers3m" :items="mydata3m" :search="search" :rows-per-page-items=[10,20,50,100,500] class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.barcode }}</td>
          <td>{{ props.item.stockno}}</td>
          <td>{{ props.item.product }}</td>
          <td>{{ props.item.categorie }}</td>
          <td>{{ props.item.unit }}</td>
          <td>{{ props.item.qty }}</td>
          <td>{{ props.item.shipped }}</td>
          <td>
            <span v-if="props.item.back > 0" class="red--text">{{ props.item.back }}</span>
            <span v-if="props.item.back == 0">{{ props.item.back }}</span>
          </td>
          <td>{{ props.item.stockin }}</td>
          <td>{{ props.item.saleout }}</td>
          <!-- <td>{{ props.item.date }}</td> -->
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initializepro">ກົດເລີ່ມໃໝ່</v-btn>
        </template>
      </v-data-table>
    </div>
  </v-app>
</template>
<script>
import firebase from 'firebase/app'
import db from '@/firebase/init'
import moment from 'moment'
  export default {
    name:'import',
    data: () => ({
      dialog: false,
      search: '',
      sldisplay:1,
      displaysl: true,
      suppliers: [],
      customers:[],
      import:[],
      export:[],
      headers: [
        {text: 'Date', value: 'date' ,align: 'left'},
        {text: 'Import/Export', value: 'import_export' ,align: 'left'},
        {text: 'Categorie', value: 'categorie' ,align: 'left'},
        {text: 'Stock Number', value: 'stockno' ,align: 'left'},
        {text: 'Bar code', value: 'barcode' ,align: 'left'},
        {text: 'Unit', value: 'unit' ,align: 'left'},
        {text: 'Product', value: 'product' ,align: 'left'},
        {text: 'Customer/Supplier', value: 'customer_supplier'  ,align: 'left'},
        // {text: 'Tax', value: 'taxid' ,align: 'left'},
        // {text: 'VAT', value: 'vat' ,align: 'left'},
        {text: 'Discount', value: 'discount' ,align: 'left'},
        {text: 'Price', value: 'price' ,align: 'left'},
        {text: 'Qty', value: 'qty' ,align: 'left'},
        {text: 'Shipped', value: 'shipped' ,align: 'left'},
        {text: 'ຄົງເຫຼືອ', value: 'back' ,align: 'left'},
        {text: 'ລວມເປັນ', value: 'amount' ,align: 'left'},
        {text: 'Stock', value: 'stock' ,align: 'left'},
      ],
      mydata: [],
      headerspro: [
        {text: 'Barcode', value: 'barcode' ,align: 'left'},
        {text: 'Stock Number', value: 'stockno' ,align: 'left'},
        {text: 'Product', value: 'product' ,align: 'left'},
        {text: 'Categorie', value: 'categorie' ,align: 'left'},
        {text: 'Unit', value: 'unit' ,align: 'left'},
        {text: 'Price', value: 'price'  ,align: 'left'},
        {text: 'Qty', value: 'qty'  ,align: 'left'}, // {text: 'Qty', value: 'qty'  ,align: 'left'},
        {text: 'Stock In', value: 'shipped' ,align: 'left'}, // {text: 'Shipped', value: 'shipped' ,align: 'left'},
        {text: 'Back', value: 'back' ,align: 'left'},
        {text: 'Balance Qty', value: 'stockin' ,align: 'left'},// {text: 'stock in', value: 'stockin' ,align: 'left'},
        {text: 'Stock Amount', value: 'stockinamount' ,align: 'left'},//        {text: 'Stock Amount', value: 'stockinamount' ,align: 'left'},
        {text: 'Stock Out/Sale Out', value: 'sellqty' ,align: 'left'},
        {text: 'Sale Out Amount', value: 'saleoutamount' ,align: 'left'},
        // {text: 'Date', value: 'date' ,align: 'left'},
      ],
      mydatapro: [],
      headers3m: [
        {text: 'Barcode', value: 'barcode' ,align: 'left'},
        {text: 'Stock Number', value: 'stockno' ,align: 'left'},
        {text: 'Product', value: 'product' ,align: 'left'},
        {text: 'Categorie', value: 'categorie' ,align: 'left'},
        {text: 'Unit', value: 'unit' ,align: 'left'},
        {text: 'Qty', value: 'qty'  ,align: 'left'},
        {text: 'Stock In', value: 'shipped' ,align: 'left'},
        {text: 'Back', value: 'back' ,align: 'left'},
        {text: 'Stock In', value: 'stockin' ,align: 'left'},
        {text: 'Balance Qty', value: 'sellqty' ,align: 'left'},
        // {text: 'Date', value: 'date' ,align: 'left'},
      ],
      mydata3m: [],
    }),
    computed: {
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    created () {
      let _this =this
      console.log(firebase.auth().currentUser.uid)
      db.collection('users').doc(firebase.auth().currentUser.uid).get()
      .then(function(doc) {
        if (doc.exists) {
          if(doc.data().stock){
            if(!doc.data().s3m){
              _this.initialize()
            } else {
              _this.initialize3m()
              _this.sldisplay = 5
              _this.displaysl = false 
            }
          }
        }
      })
    },
    methods: {
    _P (value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    checkdisplay () {
      switch (this.sldisplay) {
        case 1,2,3:
          this.initialize()
          break;
        case 4:
          this.initializepro()
          break;
        case 5:
          this.initialize3m()
          break;
        default:
          this.initialize()
          break;
      }
    },
    initialize3m () {let tdata = []
      db.collection('products').where("stt","==",1).where('sid','==','T4FNja8DBuLhdEIdgbmU').get().then(snapshot => {
        snapshot.forEach(async doc => {
          let tmpdata = {
            id:null,
            barcode: null,
            stockno:null,
            product:null,
            categorie:null,
            unit:null,
            qty:0,
            shipped:0,
            back:0,
            stockin:0,
            saleout:0,
            date:null
          }
          var docRef = db.collection("products").doc(doc.id)
          let itemin = []
          await db.collection('stock').where('stt','==',1).where('stock','==','in').where('product','==',docRef).get().then(_stock => {
            _stock.forEach(doc => {
              if(doc.exists){
                let tmpdatas = {
                  id:null,
                  price:null,
                  qty:null,
                  shipped:null,
                  back:null
                }
                tmpdatas.id = doc.id
                tmpdatas.price = doc.data().price
                tmpdatas.qty = doc.data().qty
                tmpdatas.shipped = doc.data().shipped
                tmpdatas.back = doc.data().back
                tmpdatas.amount = doc.data().amount
                const timestamp = doc.get('date')
                const date = moment(timestamp.toDate()).format('DD/MM/YYYY')
                tmpdatas.date = date
                itemin.push(tmpdatas)
              }
            })
          })
          let itemout = []
          await db.collection('stock').where('stt','==',1).where('stock','==','out').where('product','==',docRef).get().then(_stock => {
            _stock.forEach(doc => {
              if(doc.exists){
                let tmpdatas = {
                  id:null,
                  price:null,
                  qty:null,
                  shipped:null,
                  back:null
                }
                tmpdatas.id = doc.id
                tmpdatas.price = doc.data().price
                tmpdatas.qty = doc.data().qty
                tmpdatas.amount = doc.data().amount
                itemout.push(tmpdatas)
              }
            })
          })
          tmpdata.barcode = doc.data().bar
          tmpdata.stockno = doc.data().stockno
          tmpdata.product = doc.data().name
          if(doc.data().unid){
            await db.collection('unit').doc(doc.data().unid).get().then(doc => {
              if (doc.exists) {
                tmpdata.unit = doc.data().name
              }
            })
          }
          if(doc.data().cid){
            await db.collection('categories').doc(doc.data().cid).get().then(doc => {
              if (doc.exists) {
                tmpdata.categorie = doc.data().name
              }
            })
          }
          tmpdata.qty = itemin.reduce((sum_, item) => sum_ + item.qty, 0)
          tmpdata.shipped = itemin.reduce((sum_, item) => sum_ + item.shipped, 0)
          tmpdata.back = itemin.reduce((sum_, item) => sum_ + item.back, 0)
          tmpdata.stockin = itemin.reduce((sum_, item) => sum_ + item.shipped, 0) - itemout.reduce((sum_, item) => sum_ + item.qty, 0)
          tmpdata.saleout = itemout.reduce((sum_, item) => sum_ + item.qty, 0)
          if(itemin.length>0){
            let i = itemin[itemin.length-1]
            tmpdata.date = i.date
          }
          tdata.push(tmpdata)
        })
        this.mydata3m=tdata
      })
    },
    initializepro () {
      let tdata = []
      db.collection('products').where("stt","==",1).get().then(snapshot => {
        snapshot.forEach(async doc => {
          let tmpdata = {
            id:null,
            barcode: null,
            stockno:null,
            product:null,
            categorie:null,
            unit:null,
            price:0,
            qty:0,
            shipped:0,
            back:0,
            stockin:0,
            stockinamount:0,
            saleout:0,
            saleoutamount:0,
            date:null
          }
          var docRef = db.collection("products").doc(doc.id)
          let itemin = []
          await db.collection('stock').where('stt','==',1).where('stock','==','in').where('product','==',docRef).get().then(_stock => {
            _stock.forEach(doc => {
              if(doc.exists){
                let tmpdatas = {
                  id:null,
                  price:null,
                  qty:null,
                  shipped:null,
                  back:null
                }
                tmpdatas.id = doc.id
                tmpdatas.price = doc.data().price
                tmpdatas.qty = doc.data().qty
                tmpdatas.shipped = doc.data().shipped
                tmpdatas.back = doc.data().back
                tmpdatas.amount = doc.data().amount
                const timestamp = doc.get('date')
                const date = moment(timestamp.toDate()).format('DD/MM/YYYY')
                tmpdatas.date = date
                itemin.push(tmpdatas)
              }
            })
          })
          let itemout = []
          await db.collection('stock').where('stt','==',1).where('stock','==','out').where('product','==',docRef).get().then(_stock => {
            _stock.forEach(doc => {
              if(doc.exists){
                let tmpdatas = {
                  id:null,
                  price:null,
                  qty:null,
                  shipped:null,
                  back:null
                }
                tmpdatas.id = doc.id
                tmpdatas.price = doc.data().price
                tmpdatas.qty = doc.data().qty
                tmpdatas.amount = doc.data().amount
                itemout.push(tmpdatas)
              }
            })
          })
          tmpdata.barcode = doc.data().bar
          tmpdata.stockno = doc.data().stockno
          tmpdata.product = doc.data().name
          if(doc.data().unid){
            await db.collection('unit').doc(doc.data().unid).get().then(doc => {
              if (doc.exists) {
                tmpdata.unit = doc.data().name
              }
            })
          }
          if(doc.data().cid){
            await db.collection('categories').doc(doc.data().cid).get().then(doc => {
              if (doc.exists) {
                tmpdata.categorie = doc.data().name
              }
            })
          }
          tmpdata.price = doc.data().price
          tmpdata.qty = itemin.reduce((sum_, item) => sum_ + item.qty, 0)
          tmpdata.shipped = itemin.reduce((sum_, item) => sum_ + item.shipped, 0)
          tmpdata.back = itemin.reduce((sum_, item) => sum_ + item.back, 0)
          tmpdata.stockin = itemin.reduce((sum_, item) => sum_ + item.shipped, 0) - itemout.reduce((sum_, item) => sum_ + item.qty, 0)
          tmpdata.stockinamount = itemin.reduce((sum_, item) => sum_ + item.amount, 0)
          tmpdata.saleout = itemout.reduce((sum_, item) => sum_ + item.qty, 0)
          tmpdata.saleoutamount = itemout.reduce((sum_, item) => sum_ + item.amount, 0)
          if(itemin.length>0){
            let i = itemin[itemin.length-1]
            tmpdata.date = i.date
          }
          tdata.push(tmpdata)
        })
        this.mydatapro=tdata
      })
    },
    initialize () {
      let tdata = []
      let ref = db.collection('stock')
      switch (this.sldisplay) {
        case 1:
          ref = ref.where("stt","==",1)
          break;
        case 2:
          ref = ref.where("stt","==",1).where("stock","==",'in')
          break;
        case 3:
          ref = ref.where("stt","==",1).where("stock","==",'out')
          break;
        default:
          ref = ref.where("stt","==",1)
          break;
      }
      ref.get()
      .then(snapshot => {
        snapshot.forEach(async doc => {
          let tmpdata = {
            id:null,
            date: null,
            import_export:null,
            categorie:null,
            stockno:null,
            unit:null,
            product:null,
            customer_supplier:null,
            taxid:null,
            vat:null,
            discount:null,
            price:null,
            shipped:null,
            qty:null,
            back:null,
            amount:null,
            stock:null
          }
          // tmpdata.id = doc.id
          const tdate = doc.get('date')
          let _date = null
          if (tdate != null) {
            _date = moment(tdate.toDate()).format('YYYY-MM-DD')
          }
          tmpdata.date = _date
          if(doc.data().importref){
            await doc.data().importref.get().then(async doc => {
              if (doc.exists) {
                tmpdata.import_export = doc.data().invoiceno
                tmpdata.taxid = doc.data().taxid
                tmpdata.vat = doc.data().vat
                if(doc.data().sid)
                db.collection('suppliers').doc(doc.data().sid).get().then(doc => {
                  if (doc.exists) {
                    tmpdata.customer_supplier = doc.data().name
                  }
                })
              }
            })
          }
          if(doc.data().exportref){
            await doc.data().exportref.get().then(doc => {
              if (doc.exists) {
                tmpdata.import_export = doc.data().invoiceno
                tmpdata.taxid = doc.data().taxid
                tmpdata.vat = doc.data().vat
                if(doc.data().cusid){
                  db.collection('customer').doc(doc.data().cusid).get().then(doc => {
                    if (doc.exists) {
                      tmpdata.customer_supplier = doc.data().name
                    }
                  })
                }
              }
            })
          }
          if(doc.data().categorieref){
            await doc.data().categorieref.get().then(doc => {
              if (doc.exists) {
                tmpdata.categorie = doc.data().name
              }
            })
          }
          if(doc.data().stockno){
            tmpdata.stockno = doc.data().stockno
          }
          if(doc.data().unid){
            await db.collection('unit').doc(doc.data().unid).get().then(doc => {
              if (doc.exists) {
                tmpdata.unit = doc.data().name
              }
            })
          }
          if(doc.data().product){
            await doc.data().product.get().then(doc => {
              if (doc.exists) {
                tmpdata.product = doc.data().name
                tmpdata.barcode = doc.data().bar
              }
            })
          }
          if(doc.data().discount)
          tmpdata.discount = doc.data().discount
          if(doc.data().price)
          tmpdata.price = doc.data().price
          if(doc.data().qty)
          tmpdata.qty = doc.data().qty
          if(doc.data().shipped)
          tmpdata.shipped = doc.data().shipped
          if(doc.data().back)
          tmpdata.back = doc.data().back
          if(doc.data().amount)
          tmpdata.amount = doc.data().amount
          if(doc.data().stock){
            if(doc.data().stock === 'in'){
              tmpdata.stock = 'ເຂົ້າ'
            } else {
              tmpdata.stock = 'ອອກ'
            }
          }
          
          tdata.push(tmpdata)
        })
        this.mydata=tdata
      })
      .catch(err => {
        console.log('Error getting documents', err)
      })
    }
  }
}
</script>

<style>
.fontLao{
font-family: phetsarath ot !important;
}

.fixtable>div>  td:first-child,
.fixtable>div>  table.v-table tbody td:not(:first-child),
.fixtable>div>  table.v-table tbody th:first-child,
.fixtable>div>  table.v-table tbody th:not(:first-child),
.fixtable>div>  table.v-table thead td:first-child, 
.fixtable>div>  table.v-table thead td:not(:first-child),
.fixtable>div>  table.v-table thead th:first-child,
.fixtable>div>  table.v-table thead th:not(:first-child) {
    padding: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Stock.vue